import React, { useState, useEffect, useRef } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { isMobile } from "react-device-detect";

import ApiAmusementComplex from "../../../core/api/api.amusementComplex";
import {
  IconChevronDown,
  IconClipBoard,
  IconCup,
  IconErrorCircle,
  IconLocation,
  IconNote,
} from "../../../assets/icons";
import { useParams } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Slider from "../AmusementDetail/component/Slider";
import CardItem from "./Component/CardItem";
import SkeletonAmusementCardItem from "../../components/SkeletonComponent/SkeletonAmusementCardItem";
import _ from "lodash";
import { Helmet } from "react-helmet-async";
import CommentScore from "../../components/Testimonials/CommentScore";
import CommentSlider from "../../components/Testimonials/CommentSlider";
function AmusementComplex() {
  const [amusementComplex, setAmusementComplex] = useState({});
  const [loadingImageSlider, setLoadingImageSlider] = useState(true);
  const list = [1, 2, 3, 4, 5, 6];
  const [galleries, setGalleries] = useState([]);
  const { urlName } = useParams(); // دریافت پارامتر urlName از روت
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  //اسکرول به قسمت توضیحات در حالت دسکتاپ
  const ScrollGotoDescription = useRef(null);
  const handleScrollGotoDescription = () => {
    if (ScrollGotoDescription.current) {
      ScrollGotoDescription.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  //اسکرول به قسمت امتیازات در حالت دسکتاپ
  const ScrollGotoScore = useRef(null);
  const handleScrollGotoScore = () => {
    if (ScrollGotoScore.current) {
      ScrollGotoScore.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  /************************ */
  //اسکرول به قسمت نظرات در حالت دسکتاپ
  const ScrollGotoComment = useRef(null);
  const handleScrollGotoComment = () => {
    if (ScrollGotoComment.current) {
      ScrollGotoComment.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiAmusementComplex.getAmusementComplex({
          urlName,
        });
        //console.log("ApiAmusementComplex=",response);
        setAmusementComplex(response);
        setGalleries(response.amusementServiceSliders);
        setLoadingImageSlider(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoadingImageSlider(false); // بارگذاری تصاویر را به صورت پایانی تنظیم می‌کنیم
      }
    };

    fetchData();
  }, [urlName]);
  const truncateDescription = (htmlString, wordLimit) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    const text = tempDiv.textContent || tempDiv.innerText || "";

    // برش دادن متن به تعداد کلمات مورد نظر
    const words = text.split(/\s+/).slice(0, wordLimit).join(" ");

    // اضافه کردن سه نقطه در انتها اگر متن کامل نباشد
    return words + (text.split(/\s+/).length > wordLimit ? "..." : "");
  };
  return (
    <>
      {/* <ToastContainer position="top-right" rtl="true"></ToastContainer> */}
      {amusementComplex && (
        <Helmet>
          <title>{amusementComplex.pageTitle || amusementComplex.name}</title>
          <link
            rel="canonical"
            href={`${window.location.origin}/p/${amusementComplex.urlName}`}
          />
          <meta
            property="og:url"
            content={`${window.location.origin}/p/${amusementComplex.urlName}`}
          />
          <meta
            property="og:title"
            content={amusementComplex.pageTitle || amusementComplex.name}
          />
          <meta
            property="og:description"
            content={
              amusementComplex.metaDescription || "خرید ویژه با تخفیف ویژه"
            }
          />
          <meta
            name="description"
            content={
              amusementComplex.metaDescription || "خرید ویژه با تخفیف ویژه"
            }
          />
        </Helmet>
      )}
      {isMobile ? (
        //------------------------------- حالت موبایل------------------------------------------------------------
        <SkeletonTheme>
          <div className="">
            <Container fluid className="  min-height-page">
              <Container className="px-0 pt-3">
                <Col className="border shadow-sm rounded-3 p-2 bg-white swiper-with-arrow">
                  {loadingImageSlider ? (
                    <>
                      <Skeleton
                        height={258}
                        width="100%"
                        style={{ borderRadius: "0.75rem" }}
                      ></Skeleton>
                    </>
                  ) : (
                    <Slider images={galleries} />
                  )}

                  <Row>
                    <Col xs="12" sm="6">
                      {loadingImageSlider ? (
                        <Skeleton
                          height={20}
                          width="100%"
                          className="mt-3"
                        ></Skeleton>
                      ) : (
                        <h1 className="fw-bold fs-101 text-center text-sm-end pt-3">
                          {amusementComplex.name}
                        </h1>
                      )}
                    </Col>
                    <Col xs="12" sm="6">
                      <div className="fs-075 text-secondary text-center  text-sm-start small-svg  pt-sm-3">
                        {loadingImageSlider ? (
                          <Skeleton
                            height={20}
                            width="100%"
                            className="mt-2"
                          ></Skeleton>
                        ) : (
                          <>
                            <IconLocation fillColor="#444" />
                            <span className="ps-1">
                              {amusementComplex.amusementComplexRegions
                                ?.map((rgn) => rgn.region.name)
                                .join("، ")}
                            </span>
                          </>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Row className="gx-2">
                  {!loadingImageSlider
                    ? amusementComplex?.amusementServices?.map(
                        (item, index) => (
                          <CardItem
                            key={index}
                            imageUrl={
                              process.env.REACT_APP_API_URL + item.imageUrl
                            }
                            amusementName={item.name}
                            price={item.price}
                            amusementUrl={`/details/${item.urlName}`}
                            originalPrice={item.originalPrice}
                            hasReserveDetail_V2={item.hasReserveDetail_V2}
                            // {item.hasReserveDetail_V2}
                          />
                        )
                      )
                    : list.map((item, index) => (
                        <SkeletonAmusementCardItem key={index} />
                      ))}
                </Row>
                <Col className="border shadow-sm rounded-3 p-2 bg-white mt-2 ">
                  <h4 className="fs-normal fw-bold text-dark pt-1 pb-2 text-center border-bottom mb-3">
                    {loadingImageSlider ? (
                      <Skeleton height="20px"></Skeleton>
                    ) : (
                      <span> توضیحات {amusementComplex.name}</span>
                    )}
                  </h4>
                  {loadingImageSlider ? (
                    <Skeleton height="15px" count={9}></Skeleton>
                  ) : (
                    <div
                      className="text-align-justify line-height-1 description-text text-secondary-1"
                      dangerouslySetInnerHTML={{
                        __html: amusementComplex.description,
                      }}
                    />
                  )}
                </Col>
              </Container>
            </Container>
            <Container fluid className="bg-light-blue pb-3">
              <section>
                <CommentSlider amusementService={amusementComplex} type="2" />
              </section>
            </Container>
          </div>
        </SkeletonTheme>
      ) : (
        //-------------------------------- حالت دسکتاپ-----------------------------------------------------------
        <SkeletonTheme>
          <Container fluid className="  min-height-page">
            <Container className="pt-3">
              <Row className="mb-4">
                {/* -------- اسلایدر -------------------- */}

                <Col lg="5">
                  <Card className="rounded-3 border-0 shadow-sm p-2">
                    {loadingImageSlider ? (
                      <>
                        <Skeleton
                          height={258}
                          width="100%"
                          style={{ borderRadius: "0.75rem" }}
                        ></Skeleton>
                      </>
                    ) : (
                      <Slider images={galleries} />
                    )}
                  </Card>
                </Col>
                <Col lg="7" className="mt-3 mt-lg-0">
                  <Card className="rounded-3 border-0 shadow-sm p-2 h-100">
                    <Card.Body>
                      <div className="border-bottom">
                        <h1 className="fw-bold fs-103 ">
                          {!loadingImageSlider ? (
                            amusementComplex.name
                          ) : (
                            <Skeleton height={22} width="100px"></Skeleton>
                          )}
                        </h1>
                        <div className="fs-normal text-secondary  small-svg mb-3">
                          {!loadingImageSlider ? (
                            <>
                              <IconLocation fillColor="#444" />
                              <span className="ps-1">
                                {amusementComplex.amusementComplexRegions
                                  ?.map((rgn) => rgn.region.name)
                                  .join("، ")}
                              </span>
                            </>
                          ) : (
                            <Skeleton height={20} width="150px"></Skeleton>
                          )}
                        </div>
                      </div>
                      {loadingImageSlider ? (
                        <div className="mt-3 mb-2">
                          <Skeleton height="15px" count={2}></Skeleton>
                        </div>
                      ) : (
                        <div
                          className="mt-3 text-black-06 description-text d-inline-block"
                          dangerouslySetInnerHTML={{
                            __html: truncateDescription(
                              amusementComplex.description,
                              35
                            ),
                          }}
                        />
                      )}
                      <span
                        className=" small-svg  fs-075 text-danger cursor-pointer"
                        onClick={handleScrollGotoDescription}
                      >
                        ادامه متن
                        <IconChevronDown fillColor="#f80248" />
                      </span>
                      <div className="fs-085 mt-3 pb-3 pb-xl-1 d-lg-none d-xl-block">
                        <IconErrorCircle fillColor="#888" />
                        شما می توانید تمامی تفریحات این مجموعه را با بهترین قیمت
                        ، از سایت تفریحان رزرو نمایید.
                      </div>
                      <Col xs={12} className="px-0  mt-lg-3 border-top ">
                        <div className="d-flex align-items-center  pt-3 ">
                          <div className="text-center">
                            <div
                              className="fs-09 small-svg white-space-nowrap cursor-pointer"
                              onClick={handleScrollGotoScore}
                            >
                              <IconCup fillColor="black" /> امتیاز کلی
                              <span className="fwbold fs-101 ps-1">
                                {loadingImageSlider ? (
                                  <Skeleton height="15px" width={20}></Skeleton>
                                ) : (
                                  amusementComplex.totalRank
                                )}
                              </span>
                            </div>
                          </div>
                          <div
                            className="btn btn-light text-secondary fs-075 rounded-4 ms-2 white-space-nowrap"
                            onClick={handleScrollGotoScore}
                          >
                            مشاهده
                          </div>
                          <div className="text-center border-start ms-5 ps-5">
                            <div className="fs-09 small-svg white-space-nowrap ">
                              <IconClipBoard fillColor="black" /> تعداد نظرات
                              <span className=" fs-101 fwbold ps-1">
                                0{" "}
                              </span>{" "}
                            </div>
                          </div>
                          <div
                            className="btn btn-light text-secondary fs-075 rounded-4 ms-2 white-space-nowrap"
                            onClick={handleScrollGotoComment}
                          >
                            مشاهده
                          </div>
                        </div>
                      </Col>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              {/* -------- آیتم های قابل رزرو -------------------- */}
              <Col className=" mb-4">
                <Row className="gx-2 amusement-swiper">
                  {!loadingImageSlider
                    ? amusementComplex?.amusementServices?.map(
                        (item, index) => (
                          <CardItem
                            key={index}
                            imageUrl={
                              process.env.REACT_APP_API_URL + item.imageUrl
                            }
                            amusementName={item.name}
                            price={item.price}
                            amusementUrl={`/details/${item.urlName}`}
                            originalPrice={item.originalPrice}
                            hasReserveDetail_V2={item.hasReserveDetail_V2}
                          />
                        )
                      )
                    : list.map((item, index) => (
                        <SkeletonAmusementCardItem key={index} />
                      ))}
                </Row>
              </Col>

              {/* -------- توضیحات -------------------- */}
              <Card
                className="rounded-3 shadow-sm border-0 bg-white  mt-3"
                ref={ScrollGotoDescription}
              >
                <Card.Body>
                  <span className="pe-2">
                    <IconNote fillColor="#000" />
                  </span>
                  <h4 className="fs-102 fw-bold text-dark pt-1 pb-2 d-inline-block mb-3">
                    {loadingImageSlider ? (
                      <Skeleton height="20px"></Skeleton>
                    ) : (
                      <span> توضیحات {amusementComplex.name}</span>
                    )}{" "}
                  </h4>
                  {loadingImageSlider ? (
                    <Skeleton height="15px" count={9}></Skeleton>
                  ) : (
                    <div
                      className="text-align-justify description-text"
                      dangerouslySetInnerHTML={{
                        __html: amusementComplex.description,
                      }}
                    />
                  )}
                </Card.Body>
              </Card>

              {/* -------- نظرات -------------------- */}
              <Col className=" mt-4 pb-3">
                <section ref={ScrollGotoScore}>
                  <CommentScore amusementService={amusementComplex} />
                </section>
                <section ref={ScrollGotoComment}>
                  <CommentSlider amusementService={amusementComplex} type="2" />
                </section>
              </Col>
            </Container>
          </Container>
        </SkeletonTheme>
      )}
    </>
  );
}
export default AmusementComplex;
